import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { colors, glyphs } from '../../Styles';
import { ButtonList, EventNotePopover, Overlay } from '..';
import { ButtonTypes, ListData_ValueTypes, TableStyles_Types } from '../../Definitions';
import { useEditableColumnConstructor } from '../Tables/_Tables/useEditableColumnConstructor';
import { getCoreRowModel, getFilteredRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { ReactiveTable } from '../Tables/reactiveTableRenderer';

import { TestData as animalData } from '../../Assets/TestData/animalData';

interface Events_Props {
  selectedAnimal: number
}
/**
 * Events
 * @param selectedAnimal
 * @returns
 */
export default function Events({ selectedAnimal }:Events_Props) {
  const {t} = useTranslation()
  // const [editMode, setEditMode] = useState<boolean>(false)
  const [editTable, setEditTable] = useState(false);
  const animal = animalData.find((animal) => animal.animalId === selectedAnimal);

  // Date formatting function
  const formatDate = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const tableData = useMemo(() => {
    return animal && animal.calendar && animal.calendar.length > 0
      ? animal.calendar.map(event => {
          const notes = event.note || [];

          return { 
            eventName: event.eventName, 
            eventDate: formatDate(event.date),
            eventNotes: event.note ? <EventNotePopover eventName={event.eventName} eventNote={notes} glyphColor={colors.greyDarkPrimary} /> : <></>,
            id: event.eventNo 
          };
        })
      : [];
  }, [animal]);

  // #region | Events Table
  const accessorData = useMemo(() => ([
    {headerValue: t("animalPages.animal.eventName"), accessor: "eventName", type: ListData_ValueTypes.String},
    {headerValue: t("animalPages.animal.eventDate"), accessor: "eventDate", type: ListData_ValueTypes.String},
    {headerValue: t("animalPages.animal.eventNotes"), accessor: "eventNotes", type: ListData_ValueTypes.Div},
  ]),[t])
  
  const columns = useEditableColumnConstructor({
    accessorData: [...accessorData],
    tableStyle: TableStyles_Types.newTertiaryTable, 
    canEdit: editTable 
  });
  
  const table = useReactTable({
    columns,
    data: tableData,
    getCoreRowModel: getCoreRowModel(),
  })
  
  const reactiveTable = <>{ReactiveTable({table, tableType: TableStyles_Types.newTertiaryTable, emptyText: "Empty text", renderFooter: false})}</>
  // #endregion

  return ( <>
    { editTable ? <Overlay color={colors.transparent}/> : <></> }
    <div style={{position: "relative", height: "calc(100% - 50px)"}}>
        <div style={{display: "flex", position: "relative", justifyContent: "end", padding: "0px 20px", zIndex: editTable? "9999" : "0"}}>
        { editTable 
          ? <ButtonList
              contents={[t("buttons.saveBtn"), t("buttons.cancelBtn"), t("buttons.add"), t("buttons.edit")]}
              buttonType={ButtonTypes.tableButton}
              startEnhancers={[glyphs.Check({}), glyphs.Close({}), glyphs.Add({}), glyphs.Edit({}) ]}
              onClick={(i => {
                if (i === 0) {} // TODO: Save to db
                if (i === 1) {setEditTable(false)}
              })}
              disabled={[false, false, true, true]}
              overrides={(index) => ({
                baseButton: {backgroundColor: index === 3 ? colors.greyPrimary : colors.greySecondary},
                hoverStyles: {backgroundColor: colors.greyPrimary},
                disabledStyles: {opacity: index === 3 ? 1 : 0.5},
              })}
            /> 
          : <ButtonList
              contents={[t("buttons.add"), t("buttons.edit")]}
              buttonType={ButtonTypes.tableButton}
              startEnhancers={[ glyphs.Add({}), glyphs.Edit({}) ]}
              onClick={(i => {
                if (i === 0) {} // TODO: Add new event
                if (i === 1) {setEditTable(true)}
              })}
          />
        }
      </div>
      <div style={{height: "100%", boxSizing: "border-box", position: "relative", zIndex: editTable? "9999" : "0", backgroundColor: colors.greyLightSecondary, border: "5px solid"+colors.greyPrimary, borderRadius: "10px", overflowY: "hidden"}}>
        {reactiveTable}
      </div>
    </div>
  </> );
}